export default __webpack_public_path__ + "static/media/gel-vanilla-1.494145e2.jpg";